import React, { Component } from 'react'
//import PropTypes from 'prop-types'
//import {queryString} from 'query-string';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography'
import ErrorBoundary from './ErrorBoundary'

import DropDown from './DropDown'
import RmaLogic from '../Logic/Logic.ts'
import { withRouter } from 'react-router-dom'
import Divider from './Divider'
class Edit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      line: {
        sizeChartImage: { src: '', alt: '' },
        options: [],
      },
      logic: new RmaLogic(),
      showSubReasons: false,
      forCustomerService: false,
      setDialogState: props.setDialogState,
      returnReasons: []
    }
  }

  setReasonMessage = (line) => {
    var reasonText = '';
    var subReasonText = '';

    if (line.reasonId !== 0) {
      var reason = this.state.returnReasons
        .find(f => f.id === line.reasonId)
      if (reason) {
        reasonText = reason.reason
      }
    }

    if (reason && reason.id < 0) {
      var subReason = reason.subReasons
        .find(f => f.id === line.subReasonId)
      if (subReason) {
        subReasonText = subReason.reason
      }
    }

    var retVal = reasonText
    if (subReasonText) {
      retVal = `${retVal}:${subReasonText}`
    }
    line.reason = retVal;
  }


  componentDidMount() {
    var target = this.props.location.search.replace("?uiid=", "")
    let orderInfo = JSON.parse(localStorage.getItem('orderInfo') || '')
    if (orderInfo.lines) {
      var lineMatch = orderInfo.lines.find(v => v.uiid === target)
      this.setState(
        {
          line: lineMatch,
          returnReasons: orderInfo.returnReasons,
          originalLine: Object.assign({}, lineMatch)
        }
      )
    }
    this.setState({ forCustomerService: orderInfo?.forCustomerService ?? false })
  }

  handleChange = name => event => {
    var line = this.state.line
    line[name] = event.target.value
    this.setState({
      line: line
    })
  }

  handleProductSelectorChange = name => event => {
    //var logic = this.state.logic
    var line = this.state.line
    line[name] = event.target.value
    this.setState({
      line: line
    })
  }

  handleDropDownChange = name => event => {
    var line = this.state.line
    line[name] = Number(event.target.value)
    this.setReasonMessage(line)
    this.setState({
      line: line
    });

    if (name === "subReasonId") {
      if (line[name] !== 0) {
        this.setState({ subReasonError: '' })
      }
    }
    if (name === "reasonId") {
      if (line[name] !== 0) {
        this.setState({ reasonError: '' })
      }
      var reason = this.state.returnReasons.find(f => f.id === line.reasonId)
      if (reason && reason.subReasons && reason.subReasons.length) {
        this.setState({ showSubReasons: true })
      }
      else {
        this.setState({ showSubReasons: false })
      }
    }
  }

  imagePopout = (image) => {
    this.state.setDialogState(
      true,
      'Sizing Chart',
      this.renderSizeChart(image, null, () => { }),
      <></>,
      true,
      true)
  }

  editAlert = (message) => {
    this.state.setDialogState(
      true,
      'Validation',
      <p>{message}</p>,
      <></>,
      false,
      true)
  }

  okayButtonClick = (history) => {

    if (this.validate(this.state.line)) {
      let line = this.state.line
      line.hasEdits = true;
      this.setState({ line: line })
      let orderInfo = JSON.parse(localStorage.getItem('orderInfo') || '')
      let indx = orderInfo.lines.findIndex(f => f.uiid === this.state.line.uiid)
      orderInfo.lines[indx] = this.state.line
      localStorage.setItem('orderInfo', JSON.stringify(orderInfo))
      history.replace('/pages/returns/status')
    }
    else {
      window.scrollTo(0, 0)
    }
  }

  backButtonClick = (history) => {
    let line = this.state.originalLine
    if (line.isNewEdit) {
      line.isNewEdit = false
      line.hasEdits = false
      line.isReturn = false
      line.isExchange = false
      this.setState({ line: line })
      let orderInfo = JSON.parse(localStorage.getItem('orderInfo') || '')
      let indx = orderInfo.lines.findIndex(f => f.uiid === this.state.line.uiid)
      orderInfo.lines[indx] = line
      localStorage.setItem('orderInfo', JSON.stringify(orderInfo))
    }
    history.replace('/pages/returns/status')
  }

  validate = (line) => {
    var validationPassed = true;
    //validate
    if (!line.reasonId || line.reasonId === 0) {
      this.setState({ reasonError: "Required" });
      validationPassed = false;
    } else {
      this.setState({ reasonError: "" });
    }

    if (line.reasonId < 0 && (!line.subReasonId || line.subReasonId <= 0)) {
      this.setState({ subReasonError: "Required" });
      validationPassed = false;
    } else {
      this.setState({ subReasonError: "" });
    }

    if (line.isExchange) {
      if (line.options.length > 0 && line.option1 === -1) {
        this.setState({ option1Error: "Required" });
        validationPassed = false;
      }
      else {
        this.setState({ option1Error: "" });
      }
      if (line.options.length > 1 && line.option2 === -1) {
        this.setState({ option2Error: "Required" });
        validationPassed = false;
      }
      else {
        this.setState({ option2Error: "" });
      }
    }

    if ([5, 14, 18, 23, 27].find(f => f === line.reasonId) && (!line.comments || line.comments.length < 3)) {
      this.setState({ commentError: "A comment is required when selecting Other as a reason." });
      validationPassed = false;
    } else {
      this.setState({ commentError: "" });
    }


    if (line.isExchange) {
      const options = line.options;
      let variants = line.variants.filter(f => f.option1 === line.option1);
      if (options.length > 1) {
        variants = variants.filter(f => f.option2 === line.option2)
      }
      let newVariant = variants[0];
      if (newVariant) {
        if (newVariant.id === line.shopifyVariantId) {
          this.editAlert("You cannot exchange for the same item you originally ordered.");
          validationPassed = false;
        } else if (!this.state.forCustomerService && newVariant.isFinalSaleItem) {
          this.editAlert("The item you have selected is being discontinued and is no longer available for exchange.");
          validationPassed = false;
        }
        else {
          line.newSize = newVariant.title
          line.newVariantId = newVariant.id
          line.newShopifyProductId = newVariant.product_id
        }
      }
    }
    line.isValid = validationPassed
    return validationPassed
  }


  renderSizeChart = (image, width, imageClickFunc) => {
    return (
      <img src={image.src}
        alt={image.alt}
        width={width ? width : "95%"}
        style={{ border: '1px solid grey', marginLeft: 5, cursor: "pointer" }}
        onClick={() => imageClickFunc(image)}
      />
    )
  }
  render() {
    var line = this.state.line
    var reasonId = line.reasonId
    var reason = this.state.returnReasons.find(f => f.id === reasonId)
    if (reason) {
      var subReasons = reason.subReasons
    }

    const OkayButton = withRouter(({ history }) => (
      <Button color="primary" variant="contained" style={{ marginLeft: 5 }} onClick={() => { this.okayButtonClick(history) }}>Okay</Button>
    ))

    const BackButton = withRouter(({ history }) => (
      <Button variant="outlined" style={{ marginLeft: 5 }} onClick={() => { this.backButtonClick(history) }}>Back</Button>
    ))

    var skipPleaReasons = [14, 18, 34, 32, 30, 28,  31, 27]
    var commentTitle = 'Additional Comments'
    var isPlea = false
    if((line.reasonId>0 || line.subReasonId>0))
    {
      if ( ! skipPleaReasons.find(f=>f===line.reasonId || f===line.subReasonId) )
      {
        var pleaSkus = ['11W04','11W07','11A03','11A01']  
        if(pleaSkus.filter(f=>line.sku.startsWith(f)).length>0)
        {
          commentTitle="Did you know this is a new product? We really want to get it right, so if you're returning it we hope you'll tell us exactly what you didn't love about this brace."
          isPlea=true;
        }
      }
    }

      return (
        <ErrorBoundary>
          <Typography variant="h6" display="block" component="div" style={{}}  >Tell us More</Typography>

          {line.isReturn ? <></> :
            <Typography variant="subtitle2" display="block" component="div" style={{ marginLeft: 5 }}  >
              {line.productTitle}
            </Typography>}

          <Divider />

          <DropDown
            error={this.state.reasonError ? true : false}
            name="reasonId"
            value={line.reasonId}
            labelText="Primary Reason"
            helperText="Please Choose the Primary Reason you are Returning this Item:"
            onChange={this.handleDropDownChange}
          >
            <option value="0">Choose an Option</option>
            {this.state.returnReasons.map((v, i) =>
              <option key={i} value={v.id}>{v.reason}</option>
            )}
          </DropDown>



          {this.state.showSubReasons || line.reasonId < 0 ?
            <DropDown
              error={this.state.subReasonError ? true : false}
              name="subReasonId"
              value={this.state.line.subReasonId}
              labelText="Tell us More"
              helperText=""
              onChange={this.handleDropDownChange}
            >
              <option value="0">Choose an Option</option>
              {subReasons.map((v, i) =>
                <option key={i} value={v.id}>{v.reason}</option>
              )}

            </DropDown>
            : <></>}

            {isPlea?
              <Typography variant="h6" display="block" component="div" style={{marginLeft:5,color:"red",paddingBottom:"0px"}}  >{commentTitle}</Typography>
              :
              <Typography variant="h7" display="block" component="div" style={{marginLeft:5,color:"black",paddingBottom:"0px"}}  >{commentTitle}</Typography>
            }
          <TextField
            style={{ marginRight: 5,marginTop:0 }}
            error={this.state.commentError ? true : false}
            id="standard-full-width"
            //label={commentTitle}

            placeholder="Additional Comments"
            helperText={this.state.commentError}
            fullWidth
            multiline
            rowsMax="4"
            variant="outlined"
            margin="normal"
            onChange={this.handleChange('comments')}
            value={this.state.line.comments}
            InputLabelProps={{
              shrink: true,
            }}
          />


          <Divider />

          {/* <img src={line.sizeChartImage.src}
          alt={line.sizeChartImage.alt}
          width={240}
          style={{ border: '1px solid grey' }}
          onClick={() => this.props.viewImageFunction([line.sizeChartImage])}
          /> */}
          {line.isReturn ? <></> :
            <>
              {this.renderSizeChart(line.sizeChartImage, 240, () => this.imagePopout(line.sizeChartImage))}
              <Divider />

              <Typography variant="subtitle2" display="block" component="div" style={{ marginLeft: 5, marginTop: 10 }}  >
                Select from the dropdown below to exchange for a new size.
            </Typography>
              <Divider />


              {line.options.map((v, i) =>
                <DropDown
                  error={this.state["option" + v.position + "Error"] ? true : false}
                  key={i}
                  name={"option" + v.position}
                  value={line["option" + v.position]}
                  labelText={v.name}
                  helperText=""
                  onChange={this.handleProductSelectorChange}
                >
                  <option value="0">Choose an Option</option>
                  {v.values.map((val, index) =>
                    <option key={index} value={val}>{val}</option>
                  )}
                </DropDown>)}
            </>}
          <Divider />

          <Grid container direction="row" justify="flex-start" alignItems="center"   >
            <Grid item >
              <BackButton />
            </Grid>

            <Grid item>
              <OkayButton />

            </Grid>
          </Grid>
        </ErrorBoundary>
      )
  }


}
export default withRouter(Edit)